var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8468 14.0278C12.0053 14.1863 12.0944 14.4013 12.0944 14.6255C12.0944 14.8497 12.0053 15.0646 11.8468 15.2231C11.6883 15.3817 11.4733 15.4707 11.2491 15.4707C11.025 15.4707 10.81 15.3817 10.6515 15.2231L5.02649 9.59814C4.94783 9.51976 4.88541 9.42661 4.84283 9.32405C4.80024 9.22149 4.77832 9.11154 4.77832 9.00049C4.77832 8.88944 4.80024 8.77948 4.84283 8.67692C4.88541 8.57436 4.94783 8.48122 5.02649 8.40283L10.6515 2.77783C10.81 2.61932 11.025 2.53027 11.2491 2.53027C11.4733 2.53027 11.6883 2.61932 11.8468 2.77783C12.0053 2.93634 12.0944 3.15132 12.0944 3.37549C12.0944 3.59965 12.0053 3.81463 11.8468 3.97314L6.82016 8.99978L11.8468 14.0278Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretLeft);
export default __webpack_public_path__ + "static/media/CaretLeft.e8641f7c0508bcd35eb4daebbb37de61.svg";
export { ForwardRef as ReactComponent };